module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fb-Gc-Hc-Ia-Gc.aebbb892.png";